// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken } from "firebase/messaging";
import AppApi from "../api/app";
import { onMessage } from "firebase/messaging";
import store from "../store/store";
import Actions from "../store/actions";


const firebaseConfig = {
 apiKey: "AIzaSyB8_zuoRcPx20QLwqrIhcCfb2loPONm_sU",
 authDomain: "shop-42759.firebaseapp.com",
 projectId: "shop-42759",
 storageBucket: "shop-42759.firebasestorage.app",
 messagingSenderId: "350069829744",
 appId: "1:350069829744:web:633c69d42324aaa6c204b5",
 measurementId: "G-BR341KJHST"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const messaging = getMessaging(app);


export const generateToken = async () => {
 if ("Notification" in window) {
  Notification.requestPermission().then(async function (result) {
   if (result === "granted") {
    let token = await getToken(messaging, {
     vapidKey: "BIHDk44yY9zU3i-KniQJSEnbPBEEneTshU6bvK_FyBnzKSLqgMzgKcLXY6zw0KJqR19dxOT8QjSFe-r31U_gA-c"
    })
    if (token) {
     let res = await AppApi.updateProfile({ fcmToken: token });
     console.log("You have enable desktop notifications.", token, res);
     onMessage(messaging, (payload) => {
      console.log("New message received. ", payload);

      var notification = new Notification(payload?.notification?.title, {
       body: payload?.notification?.body,
      });
      notification.onclick = function () {
       window.open(payload?.data?.link, '_blank');
       notification.close();
      };
      if (payload?.data?.type == "ORDER_NEW_ORDER") orderReceived(JSON.parse(payload?.data?.data));
     })
    }
   }
  });
 } else {
  console.log("This browser does not support desktop notifications.");
 }
}


// *************************************************
// notifications alert

let orderReceived = (data) => {
 store.dispatch(Actions.newOrderRevived(1));
 store.dispatch(Actions.addOrder(data));
}